// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QnIS","icon":"styles_icon__2mL3R"};